import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const FooterFacebook: React.FC<SvgIconProps> = ({
  width = 28,
  height = 28,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 28 28'
    fill='none'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 0V28H28V0H0ZM22.773 7.48672H20.9639C19.1822 7.48672 18.6255 8.5925 18.6255 9.72781V12.4184H22.6056L21.9691 16.5659H18.6255V26.25H14.1422V16.5659H10.5V12.4184H14.1422V9.25859C14.1422 5.66234 16.2848 3.675 19.5617 3.675C21.1313 3.675 22.773 3.95609 22.773 3.95609V7.48672Z'
      fill={fill}
    />
  </svg>
)

export default FooterFacebook
